export default "__VITE_ASSET__B4cyc4fm__"